var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.element.options !== null && _vm.element.options.attrs !== null
    ? _c(
        "el-form",
        {
          ref: "form",
          staticStyle: { width: "100%" },
          attrs: { model: _vm.form, rules: _vm.rules },
        },
        [
          _c(
            "div",
            { staticClass: "de-number-range-container" },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { "padding-left": "0px" },
                  attrs: { prop: "min" },
                },
                [
                  _c("el-input", {
                    ref: "de-number-range-min",
                    attrs: {
                      placeholder: _vm.$t(
                        _vm.element.options.attrs.placeholder_min
                      ),
                      size: _vm.size,
                    },
                    on: { input: _vm.inputChange, change: _vm.handleMinChange },
                    model: {
                      value: _vm.form.min,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "min", $$v)
                      },
                      expression: "form.min",
                    },
                  }),
                ],
                1
              ),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("denumberrange.split_placeholder"))),
              ]),
              _c(
                "el-form-item",
                {
                  staticStyle: {
                    "padding-right": "0px",
                    width: "calc(50% - 4px) !important",
                  },
                  attrs: { prop: "max" },
                },
                [
                  _c("el-input", {
                    ref: "de-number-range-max",
                    attrs: {
                      placeholder: _vm.$t(
                        _vm.element.options.attrs.placeholder_max
                      ),
                      size: _vm.size,
                    },
                    on: { input: _vm.inputChange, change: _vm.handleMaxChange },
                    model: {
                      value: _vm.form.max,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "max", $$v)
                      },
                      expression: "form.max",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }